import { DrupalNodeBasicPage, DrupalNodeRelease, DrupalTaxonomyTerm } from "@/types"
import { PageContent } from "../app/drupal/PageContent"
import { DocumentSidebar, DocumentSidebarLoading } from "../block/document-sidebar"
import { AcquianFeedback } from "../block/AcquianFeedback.client"
import { PageInterface } from "./PageInterface"
import { ContentHelp } from "../block/ContentHelp.client"
import { TocSidebar } from "../block/TocSidebar.client"
import { ServerReleaseNotes } from "../block/ReleaseNotes"
import { ProductNotifications } from "../block/ProductNotifications"
import { Suspense } from "react"
import { VersionsProvider } from "@/contexts/VersionsProvider"
import { getChildrenTerms } from "@/lib/drupal/drupal.server"
import { RelatedFAQ } from "../block/RelatedFAQ"
import { InThisSection } from "../block/InThisSection"

export const Document = async <T extends DrupalNodeBasicPage | DrupalNodeRelease>({resource, version, revision, path }: PageInterface<T>) => {
  const product = resource.field_product
  const productCurrentVersion = product.field_current_version?.name

  let versionPromise = Promise.resolve<DrupalTaxonomyTerm[]>([])

  if (resource.type == 'node--page' && resource.field_product_version?.length && resource.field_product_version[0].parent) {
    versionPromise = getChildrenTerms<DrupalTaxonomyTerm>(resource.field_product_version[0].parent[0], {
      'sort[sort-weight][path]': 'weight',
      'sort[sort-weight][direction]': 'DESC',
    })
  }

  return <VersionsProvider name={product.name} current={version ?? productCurrentVersion} versions={versionPromise}>
    <Suspense fallback={<DocumentSidebarLoading />}>
      <DocumentSidebar resource={resource} product={product} version={version ?? productCurrentVersion} path={path} />
    </Suspense>
    <TocSidebar main={
      <>
          <Suspense>
            <ProductNotifications product={product} />
          </Suspense>
          <PageContent resource={resource} revision={revision} version={version} path={path} />
          <Suspense>
            <RelatedFAQ resource={resource} />
          </Suspense>
          <AcquianFeedback resource={resource} />
          <ContentHelp resource={resource} />
      </>
    }>{resource.type == 'node--release' && <ServerReleaseNotes style="sidebar-list" product={product} />}</TocSidebar>
    </VersionsProvider>
}

export const DocumentLoading = async () => {
  return <>
    <nav className="bg-gradient-to-bl bg-gray-400 to-navy-400 animate-pulse h-screen rounded">&nbsp;
    </nav>
    <div className="bg-gradient-to-br from-gray-400 to-navy-400 animate-pulse col-span-3 h-screen rounded">&nbsp;</div>
  </>
}